// TODO: Fix type defs of import.meta.env and tsconfig import.meta support
/**
 * User type definition
 * @typedef {Object} Properties
 * @property {string} adtagCdnUri
 * @property {string} dataApiUri
 * @property {string} debugUri
 * @property {string} previewApiUri
 */

/** @type Properties */
const properties = {
  adtagCdnUri: import.meta.env.VITE_ADTAG_CDN,
  dataApiUri: import.meta.env.VITE_DATA_API,
  debugUri: import.meta.env.VITE_DEBUG_URL,
  previewApiUri: import.meta.env.VITE_PREVIEW_API
};

export default properties;
